import type { APIError } from '../types/apierror';

export const handleErrors = (error: APIError) => {
  const { response } = error;

  if (response?.status === 401 || response?.status === 419) {
    const { pathname } = window.location;
    if (pathname.indexOf('/login') < 0) {
      window.location.href = '/login';
    }
  }

  const errors: string[] = [];
  if (response?.status && response?.status > 400 && response?.data?.errors) {
    Object.keys(response?.data?.errors ?? {}).forEach((errorKey) => {
      const errorValue = response.data.errors?.[errorKey];
      if (Array.isArray(errorValue)) {
        errors.push(...errorValue);
      } else if (errorValue) {
        errors.push(errorValue);
      }
    });
  }

  return {
    ...response.data,
    status: response.status,
    error: response.data.error || true,
    message: errors.length > 0 ? errors.join(', ') : response.data.message,
  };
};
